import React from 'react';

import usePreCompRegistrationLocationInstructorTraining from './UsePreCompRegistrationLocationInstructorTraining';

import PreCompRegistrationConstants from '../utils/PreCompRegistrationConstants';

import PreCompLocationInstructorTrainingForm from '../../preComp/components/forms/PreCompLocationInstructorTrainingForm';

import PopUpModal from '@usas/ui-web/components/dialogs/PopUpModal';
import PrimaryButton from '@usas/ui-web/components/buttons/PrimaryButton';
import SecondaryButton from '@usas/ui-web/components/buttons/SecondaryButton';
import Headings from '@usas/ui-web/components/headings/Headings';
import LeftNav from '@usas/ui-web/components/leftNav/LeftNav';
import Constants from '@usas/ui-web/utils/Constants';

const PreCompRegistrationLocationInstructorTraining = () => {
  const {
    isLoading,
    formState,
    errorState,
    locationRegistrationNavState,
    onFormValueChanged,
    onValueTextPairChanged,
    onContinueClicked,
    onBackClicked
  } = usePreCompRegistrationLocationInstructorTraining();

  return (
    <LeftNav title={PreCompRegistrationConstants.LEFT_NAV_TITLE} state={locationRegistrationNavState} validateBeforeRedirect={false}>
      <Headings.H3>Location Instructor Training</Headings.H3>
      <form noValidate>
        <PreCompLocationInstructorTrainingForm
          formState={formState}
          errorState={errorState}
          onFormValueChanged={onFormValueChanged}
          onValueTextPairChanged={onValueTextPairChanged} />
        {errorState.errorOnSubmitAction &&
          <div className="row">
            <div className="col-xs-12">
              <p className={global.ErrorMessage}>{errorState.errorOnSubmitAction || ''}</p>
            </div>
          </div>}
        <div className="row usas-extra-top-margin usas-extra-bottom-margin">
          <div className="col-xs-12 usas-extra-top-margin">
            <PrimaryButton type="button" onClick={onContinueClicked}>Continue</PrimaryButton>&nbsp;
            <SecondaryButton type="button" onClick={onBackClicked}>Back</SecondaryButton>
          </div>
        </div>
      </form>
      <PopUpModal
        widthPct={50}
        maxWidth={250}
        title={Constants.LOADING_MSG}
        displayPopUp={isLoading} />
    </LeftNav>
  );
};

export default PreCompRegistrationLocationInstructorTraining;